export default __webpack_public_path__ + "static/media/unipan_logo.20342b53.jpg";